.searchRoot {
  display: var(--haus-search__searchRoot__display, flex);
  flex-direction: var(--haus-search__searchRoot__flex-direction, column);
  gap: var(--haus-search__searchRoot__gap, 1rem);
  width: var(--haus-search__searchRoot__width, 100%);
}

.inputWrapper {
  display: var(--haus-search__inputWrapper__display, flex);
  align-items: var(--haus-search__inputWrapper__align-items, center);
  position: var(--haus-search__inputWrapper__position, relative);
  width: var(--haus-search__inputWrapper__width, 100%);
}

.searchLabel {
  position: var(--haus-search__searchLabel__position, absolute);
  width: var(--haus-search__searchLabel__width, 1px);
  height: var(--haus-search__searchLabel__height, 1px);
  padding: var(--haus-search__searchLabel__padding, 0);
  margin: var(--haus-search__searchLabel__margin, -1px);
  overflow: var(--haus-search__searchLabel__overflow, hidden);
  clip: var(--haus-search__searchLabel__clip, rect(0, 0, 0, 0));
  white-space: var(--haus-search__searchLabel__white-space, nowrap);
  border: var(--haus-search__searchLabel__border, 0);
}

.searchInput {
  width: var(--haus-search__searchInput__width, 100%);
  padding: var(--haus-search__searchInput__padding, 0.75rem 3rem 0.75rem 1rem);
  border: var(--haus-search__searchInput__border, 1px solid #ddd);
  border-radius: var(--haus-search__searchInput__border-radius, 8px);
  font-family: var(
    --haus-search__searchInput__font-family,
    var(--haus-typography-body-font-family, 'Inter', sans-serif)
  );
  font-size: var(--haus-search__searchInput__font-size, 16px);
  font-weight: var(
    --haus-search__searchInput__font-weight,
    var(--haus-typography-body-font-weight, 400)
  );
  line-height: var(
    --haus-search__searchInput__line-height,
    var(--haus-typography-body-line-height, 1.5)
  );
  outline: var(--haus-search__searchInput__outline, 2px solid transparent);

  &:focus-visible {
    outline: var(
      --haus-search__searchInput__focus-visible__outline,
      2px solid var(--haus-color-primary, #000)
    );
    outline-offset: var(--haus-search__searchInput__focus-visible__outline-offset, 2px);
    border-color: var(--haus-search__searchInput__focus-border-color, #333);
  }

  &::placeholder {
    color: var(--haus-search__searchInput__placeholder-color, #888);
  }
}

.searchIconWrapper {
  position: var(--haus-search__searchIconWrapper__position, absolute);
  right: var(--haus-search__searchIconWrapper__right, 1rem);
  top: var(--haus-search__searchIconWrapper__top, 50%);
  transform: var(--haus-search__searchIconWrapper__transform, translateY(-50%));
  display: var(--haus-search__searchIconWrapper__display, flex);
  align-items: var(--haus-search__searchIconWrapper__align-items, center);
  pointer-events: var(--haus-search__searchIconWrapper__pointer-events, none);
}

.searchIcon {
  color: var(--haus-search__searchIcon__color, #666);
}

.clearButton {
  align-self: var(--haus-search__clearButton__align-self, flex-start);
  background: var(--haus-search__clearButton__background, transparent);
  border: var(--haus-search__clearButton__border, none);
  cursor: var(--haus-search__clearButton__cursor, pointer);
  padding: var(--haus-search__clearButton__padding, 0.25rem);
  font-size: var(--haus-search__clearButton__font-size, 0.875rem);

  &:focus-visible {
    outline: var(
      --haus-search__clearButton__focus-visible__outline,
      2px solid var(--haus-color-primary, #000)
    );
    outline-offset: var(--haus-search__clearButton__focus-visible__outline-offset, 2px);
  }
}

.loading,
.empty,
.error {
  padding: var(--haus-search__loading__padding, 1rem);
}

.resultsWrapper {
  display: var(--haus-search__resultsWrapper__display, flex);
  flex-direction: var(--haus-search__resultsWrapper__flex-direction, column);
  gap: var(--haus-search__resultsWrapper__gap, 0);
}

.popularSearchesHeading {
  font-weight: var(--haus-search__popularSearchesHeading__font-weight, 700);
  margin: var(--haus-search__popularSearchesHeading__margin, 0 0 0.5rem 0);
}

.collectionItem {
  display: var(--haus-search__collectionItem__display, flex);
  align-items: var(--haus-search__collectionItem__align-items, center);
  gap: var(--haus-search__collectionItem__gap, 1rem);
  padding: var(--haus-search__collectionItem__padding, 0.75rem 0);
  text-decoration: var(--haus-search__collectionItem__text-decoration, none);
  color: var(--haus-search__collectionItem__color, inherit);
  border-bottom: var(--haus-search__collectionItem__border-bottom, 1px solid #eee);

  &:hover {
    .collectionName {
      text-decoration: var(--haus-search__collectionName__hover-text-decoration, underline);
    }
  }
}

.collectionImageWrapper {
  flex-shrink: var(--haus-search__collectionImageWrapper__flex-shrink, 0);
  width: var(--haus-search__collectionImageWrapper__width, 64px);
  height: var(--haus-search__collectionImageWrapper__height, 64px);
  border-radius: var(--haus-search__collectionImageWrapper__border-radius, 8px);
  overflow: var(--haus-search__collectionImageWrapper__overflow, hidden);
  background: var(--haus-search__collectionImageWrapper__background, #f5f5f5);
}

.collectionImage {
  width: var(--haus-search__collectionImage__width, 100%);
  height: var(--haus-search__collectionImage__height, 100%);
  object-fit: var(--haus-search__collectionImage__object-fit, cover);
}

.collectionName {
  font-weight: var(--haus-search__collectionName__font-weight, 500);
}

.viewFullResults {
  margin-top: var(--haus-search__viewFullResults__margin-top, 1rem);
  width: var(--haus-search__viewFullResults__width, 100%);
}

.resultsList {
  list-style: var(--haus-search__resultsList__list-style, none);
  margin: var(--haus-search__resultsList__margin, 0);
  padding: var(--haus-search__resultsList__padding, 0);
  display: var(--haus-search__resultsList__display, flex);
  flex-direction: var(--haus-search__resultsList__flex-direction, column);
  gap: var(--haus-search__resultsList__gap, 0);
}

.resultItem {
  margin: var(--haus-search__resultItem__margin, 0);
  padding: var(--haus-search__resultItem__padding, 0);
  border-bottom: var(--haus-search__resultItem__border-bottom, 1px solid #eee);

  &:last-child {
    border-bottom: var(--haus-search__resultItem__last-border-bottom, none);
  }
}

.resultLink {
  display: var(--haus-search__resultLink__display, flex);
  align-items: var(--haus-search__resultLink__align-items, stretch);
  gap: var(--haus-search__resultLink__gap, 1rem);
  padding: var(--haus-search__resultLink__padding, 0.75rem 0);
  text-decoration: var(--haus-search__resultLink__text-decoration, none);
  color: var(--haus-search__resultLink__color, inherit);

  &:hover {
    .productName {
      text-decoration: var(--haus-search__productName__hover-text-decoration, underline);
    }
  }
}

.resultMain {
  flex: var(--haus-search__resultMain__flex, 1);
  min-width: var(--haus-search__resultMain__min-width, 0);
  display: var(--haus-search__resultMain__display, flex);
  flex-direction: var(--haus-search__resultMain__flex-direction, row);
  flex-wrap: var(--haus-search__resultMain__flex-wrap, wrap);
  justify-content: var(--haus-search__resultMain__justify-content, space-between);
  align-items: var(--haus-search__resultMain__align-items, stretch);
  gap: var(--haus-search__resultMain__gap, 1rem);
}

.resultImageWrapper {
  flex-shrink: var(--haus-search__resultImageWrapper__flex-shrink, 0);
  width: var(--haus-search__resultImageWrapper__width, 64px);
  height: var(--haus-search__resultImageWrapper__height, 64px);
  border-radius: var(--haus-search__resultImageWrapper__border-radius, 8px);
  overflow: var(--haus-search__resultImageWrapper__overflow, hidden);
  background: var(--haus-search__resultImageWrapper__background, #f5f5f5);
}

.resultImage {
  width: var(--haus-search__resultImage__width, 100%);
  height: var(--haus-search__resultImage__height, 100%);
  object-fit: var(--haus-search__resultImage__object-fit, cover);
}

.resultContent {
  flex: var(--haus-search__resultContent__flex, 1);
  min-width: var(--haus-search__resultContent__min-width, 0);
  align-self: var(--haus-search__resultContent__align-self, center);
  display: var(--haus-search__resultContent__display, flex);
  flex-direction: var(--haus-search__resultContent__flex-direction, column);
  gap: var(--haus-search__resultContent__gap, 0.25rem);
}

.productName {
  font-weight: var(--haus-search__productName__font-weight, 500);
}

.productVariant {
  font-size: var(--haus-search__productVariant__font-size, 0.875rem);
  color: var(--haus-search__productVariant__color, #666);
}

.resultPrice {
  flex-shrink: var(--haus-search__resultPrice__flex-shrink, 0);
  align-self: var(--haus-search__resultPrice__align-self, center);
}

.price {
  font-weight: var(--haus-search__price__font-weight, 600);
}
